import React from 'react';

import fetch from '../fetch';

import moment from 'moment';

import utils from '../../utils';

import {Modal, message,Progress ,Popover, Tag} from 'antd';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号'},
    {key:'progressCode', label: '编号', width: 100},
    {key:'progressName', label: '名称', width: 120, render: (value,row) =>
    <span> 
        <Popover placement="topLeft" style={{ width: 300 }}  content={
            <div style={{ width: 200 }}>
                {
                    row.categoryPathStr
                }
            </div>} 
            title="分类路径"
            >
            {value}
        </Popover>
    </span> 
    },
    {key:'progressValue', label: '任务进度' ,
            render:(value) => <Progress percent={parseInt(value)} />  },
    {key:'budgetValue', label: '预算（万元）', width: 100},
    {key:'expenseValue', label: '经费（万元）', width: 100},
    {key:'expenseProgress', label: '经费执行进度' ,
            render:(value) => value > 100 ? <Progress percent={parseInt(value)} status={'exception'} /> : 
            <Progress percent={parseInt(value)}/> },
    {key:'warnStatus', label: '预警', 
            render: (value) => value == "WARNING" ? 
            <Tag color='#f5222d'>预警</Tag>: ''},
]);

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('supv/progressView/query', keywords)
    .then(response => {
        return {
            data: response.payload.data,
            meta: response.payload.meta
        };
    })
    .then(res => (Object.assign({
        result: res.data.dataList || [],
        checked: false,
        meta: res.meta,
        total: res.data.total,
        pageIndex: res.data.pageNum,
        pageSize: res.data.pageSize,
        notify: (res.data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

const getSelection =() => {
    return DataGrid.selections;
}

const getSelectionData =() => {
    return DataGrid.selectData;
}

export default {
    querySearch,
    columns,
    onSelect,
    onSelectData,
    setRefresh,
    getSelection,
    getSelectionData
}